import axios from 'axios';
import { getCookie } from './cookies';

export class AumeeAnalytics {
    static scrollElementId = null;
    static parametersToInsert = {};
    static popStateCallbacks = {};

    static init(){
        window.addEventListener('click', AumeeAnalytics.onClickDetected, { capture: true });
        window.addEventListener('popstate', () => {
            Object.keys(AumeeAnalytics.popStateCallbacks).forEach(
                k => {
                    AumeeAnalytics.popStateCallbacks[k]()
                }
            );
        });
    }
    
    static setScrollElementId(id) {
        AumeeAnalytics.scrollElementId = id;
    }

    static addPopStateCallback(name, callback) {
        AumeeAnalytics.popStateCallbacks[name] = callback;
    }

    static removePopStateCallback(name) {
        delete AumeeAnalytics.popStateCallbacks[name];
    }

    /**
     * Add a parameter to insert in the heat map data.
     * @param name Name of the parameter
     * @param callToRetreive Function to retreive the parameter
     */
    static addParameterToInsert(
        name,
        callToRetreive,
    ) {
        AumeeAnalytics.parametersToInsert[name] = callToRetreive;
    }

	static onClickDetected(event) {
        const data = {
            url: window.location.href,
            screen_width: window.innerWidth,
            screen_height: window.innerHeight,
            event_type: 'click',
            event_x: event.x,
            event_y: event.y,
            insert_parameters: {},
        };

        if (AumeeAnalytics.scrollElementId) {
            const scrollElement = document.getElementById(
                AumeeAnalytics.scrollElementId,
            );
            data.insert_parameters['scroll'] = scrollElement?.scrollTop;
        }

        Object.keys(AumeeAnalytics.parametersToInsert).forEach((k) => {
            data.insert_parameters[k] = AumeeAnalytics.parametersToInsert[k]();
        });
        
        const sessionId = getCookie('aumee-session-id');
        const options = { headers: {"Session-Id": sessionId, 'Content-Type': 'application/json'}};
        axios.post('/analytics', data, options);
    }
}